export const timeOffViewTypes = {
  LIST: 'list',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
}
